import { z } from 'zod';

export const baseFinSwimPerformanceFormSchema = z.object({
    completionTime: z.number().min(0).nullable().optional(),
    date: z.date(),
});

export const createFinSwimPerformanceFormSchema = baseFinSwimPerformanceFormSchema
    .extend({
        userId: z.string().min(1, { message: 'Trainee is required' }),
        assessmentRunId: z.string().nullable().optional(),
        isTiedToAssessmentRun: z.boolean(),
    })
    .refine(data => !(data.isTiedToAssessmentRun && !data.assessmentRunId), {
        message: 'Assessment run is required when tying to an assessment run',
        path: ['assessmentRunId'],
    });

export type CreateFinSwimPerformanceFormData = z.infer<typeof createFinSwimPerformanceFormSchema>;

export type EditFinSwimPerformanceFormData = z.infer<typeof baseFinSwimPerformanceFormSchema> & {
    completionTimeMinutes?: number | null;
    completionTimeSeconds?: number | null;
    assessmentRunId?: string | null;
    isTiedToAssessmentRun?: boolean;
};

export const finSwimPerformanceDefaultFormValues: CreateFinSwimPerformanceFormData = {
    completionTime: null,
    date: new Date(),
    assessmentRunId: null,
    isTiedToAssessmentRun: false,
    userId: '',
};
